/**
 * /terms: the Terms of Use, readable by anybody — linked from the landing page's footer, from the
 * sign-up form and from the dialog that asks for acceptance. Signed out it stands alone; signed in
 * it sits inside the app like any other page.
 */

import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useI18n } from '../lib/i18n'
import { TermsText } from '../components/TermsOfUse'

export default function Terms({ standalone = false }: { standalone?: boolean }) {
  const { t } = useI18n()
  const navigate = useNavigate()

  const back = (
    <a
      href={standalone ? '/sign-in' : '/'}
      className="btn btn--ghost btn--sm terms-page__back"
      onClick={(event) => {
        // Back to wherever the reader came from in this app; a page opened on its own goes home.
        if (window.history.length > 1) {
          event.preventDefault()
          navigate(-1)
        }
      }}
    >
      <ArrowLeft size={14} aria-hidden /> {t('terms.back')}
    </a>
  )

  const content = (
    <div className="terms-page">
      {back}
      <TermsText />
      {back}
    </div>
  )

  return standalone ? <div className="terms-page__standalone">{content}</div> : content
}
